import React from 'react';
import { RotateCcw, RefreshCw, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

export const STATUS = {
  approved: ['معتمد — بانتظار Deploy', 'bg-blue-100 text-blue-700'],
  applying: ['قيد التطبيق', 'bg-indigo-100 text-indigo-700'],
  applied: ['مطبَّق', 'bg-emerald-100 text-emerald-700'],
  failed: ['فشل', 'bg-rose-100 text-rose-700'],
  rolling_back: ['قيد الاسترجاع', 'bg-amber-100 text-amber-700'],
  rolled_back: ['مسترجَع', 'bg-slate-200 text-slate-700'],
  superseded: ['استُبدل بإصدار أحدث', 'bg-slate-100 text-slate-500'],
};

export const fmt = (s) => (s ? new Date(s).toLocaleString('ar-EG') : '—');

export const StatusBadge = ({ status }) => {
  const [label, cls] = STATUS[status] || [status, 'bg-slate-100'];
  return <span data-testid="release-status-badge" className={`px-2 py-0.5 rounded-full text-xs font-bold ${cls}`}>{label}</span>;
};

const Counts = ({ c }) => (
  <span className="text-xs text-slate-600">
    إضافة {c.added || 0} · تحديث {c.updated || 0} · حذف {c.deleted || 0}{c.kept_live ? ` · إبقاء الحي ${c.kept_live}` : ''}
  </span>
);

export const ReleasesList = ({ releases, busy, onAction }) => (
  <section className="rounded-2xl bg-white border border-slate-200" data-testid="publish-releases">
    <h3 className="p-4 font-bold text-slate-900 border-b border-slate-100">تقارير النشر</h3>
    {releases.length === 0 && <p className="p-4 text-sm text-slate-500">لا توجد إصدارات بعد.</p>}
    <ul className="divide-y divide-slate-100">
      {releases.map(r => (
        <li key={r.id} data-testid={`release-${r.id}`} className="p-4 space-y-1">
          <div className="flex flex-wrap items-center gap-3">
            <StatusBadge status={r.status} />
            <span className="text-sm text-slate-700">اعتُمد: {fmt(r.created_at)}</span>
            {r.applied_at && <span className="text-sm text-slate-700">طُبّق: {fmt(r.applied_at)}</span>}
            <span className="flex-1" />
            {r.status === 'failed' && (
              <Button size="sm" data-testid={`release-retry-${r.id}`} disabled={!!busy} onClick={() => onAction(r.id, 'retry')}>
                {busy === 'retry' + r.id ? <Loader2 className="w-4 h-4 ms-1 animate-spin" /> : <RefreshCw className="w-4 h-4 ms-1" />}إعادة المحاولة
              </Button>
            )}
            {r.status === 'applied' && (
              <Button size="sm" variant="outline" data-testid={`release-rollback-${r.id}`} disabled={!!busy}
                onClick={() => window.confirm('استرجاع محتوى الموقع الحي إلى ما قبل هذا النشر؟') && onAction(r.id, 'rollback')}>
                <RotateCcw className="w-4 h-4 ms-1" />استرجاع هذا الإصدار
              </Button>
            )}
          </div>
          <div><span className="text-xs text-slate-500">المعتمد: </span><Counts c={r.counts || {}} /></div>
          {r.report && <div><span className="text-xs text-slate-500">المطبَّق فعلياً: </span><Counts c={r.report} /></div>}
          {r.error && <p data-testid={`release-error-${r.id}`} className="text-xs text-rose-700">سبب الفشل: {r.error}</p>}
          {r.skipped_conflicts?.length > 0 && <p className="text-xs text-amber-700">تعارضات لم تدخل الإصدار: {r.skipped_conflicts.map(s => s.title).join('، ')}</p>}
          {r.warnings?.length > 0 && <p className="text-xs text-amber-700">تحذيرات الروابط: {r.warnings.length}</p>}
        </li>
      ))}
    </ul>
  </section>
);
